import { useCallback, useState } from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import useDebounce from "../../hooks/useDebounce";
import { useCheckinRegistrationHistory } from "../../hooks/useCheckinRegistration";
import DeviceManagerTabsHeader from "./DeviceManagerTabsHeader";
import CheckinRegistrationTable from "./checkinRegistrationTable";

// Chấm công luồng mới - Bước 1: lịch sử đăng ký / đổi / xoá thiết bị + địa điểm chấm công
const headers = [
  { label: "Thời gian", key: "createdAt", width: "9%" },
  { label: "Mã NV", key: "code", width: "7%" },
  { label: "Tên NV", key: "name", width: "11%" },
  { label: "Hành động", key: "action", width: "9%" },
  { label: "Thiết bị (cũ → mới)", key: "device", width: "22%" },
  { label: "Địa điểm (cũ → mới)", key: "place", width: "18%" },
  { label: "Người thực hiện", key: "creator", width: "10%" },
  { label: "Lý do", key: "reason", width: "12%" },
];

const TableCheckinRegistrationHistory = () => {
  const [search, setSearch] = useState("");
  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => setSearch(e.target.value), []);

  const {
    items,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useCheckinRegistrationHistory(debouncedSearchTerm);

  return (
    <>
      <DeviceManagerTabsHeader onRefreshCurrentTab={() => refetch()} />

      <Box mt={{ base: "23px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex p={"16px 16px 12px 16px"}>
            <InputGroup
              maxW="42vw"
              minW={"42vw"}
              borderRadius={{ base: "8px" }}
              w={{ base: "100%" }}
            >
              <Input
                placeholder="Tên NV, mã NV, mã thiết bị ..."
                type="text"
                borderRadius={{ base: "8px" }}
                border={{ base: "1px solid var(--color-boder)" }}
                backgroundColor={"var(--fill-avatar)"}
                onChange={(e) => {
                  onChangeSearch(e);
                  setCurrentPage(1);
                }}
              />
              <InputRightElement
                borderTopRightRadius={"8px"}
                borderBottomRightRadius={"8px"}
                pointerEvents="none"
                backgroundImage="var(--color-button)"
              >
                <SearchIcon color="var(--color-main)" />
              </InputRightElement>
            </InputGroup>
          </Flex>

          <CheckinRegistrationTable
            headers={headers}
            rows={items}
            isLoaded={!isLoading && !isRefetching}
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={(p) => setCurrentPage(p.selected + 1)}
            startEntry={startEntry}
            endEntry={endEntry}
            entries={entries}
          />
        </Flex>
      </Box>
    </>
  );
};

export default TableCheckinRegistrationHistory;
